import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import scrollbars from '@helpers/scrollbars';
import { h2, link, paragraphLarge } from '@helpers/typography';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import styled, { css } from 'styled-components';
const MenuStyles = css `
  ${transition('left')};
  ${scrollbars};

  position: fixed;
  top: var(--headerNavHeight);
  left: -150%;
  height: calc(100dvh - var(--headerNavHeight));
  width: 100%;
  overflow: auto;
  overflow-x: hidden;

  &[data-active='true'] {
    left: 0;
  }
`;
const Container = styled.nav `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${MenuStyles};

  background-color: ${brand.white};
  padding: 55px 11px 1px;
`;
const ItemContainer = styled.div `
  ${MenuStyles};

  background-color: ${brand.black};
  padding: 14px 11px;
`;
const QuickLinks = styled.ul `
  margin-top: 50px;
  border-top: 2px solid ${brand.lightGrey};
  padding-top:50px;
  flex: 1;
`;
const QuickLink = styled.a `
  ${link};

  font-size: 18px;
  line-height: 28px;
  display: flex;
  gap: 3px;
  align-items: center;
  text-decoration: none;
  color: ${brand.black};
  margin-bottom: 19px;

  svg {
    width: 18px;
    height: 18px;
  }
`;
const TopLinks = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex: 1;
  justify-content: flex-end;
`;
const TopLink = styled.a `
  ${h2};

  line-height: 1;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 45px;

  ${Container} & {
    color: ${brand.black};
    margin-bottom: 0px;
  }

  ${ItemContainer} & {
    color: ${brand.white};
    padding-left: 14px;
    margin-bottom: 27px;
  }
`;
const PreText = styled.span `
  color: ${brand.yellow};
  font-size: 20px;
  margin-bottom: 0;
`;
const BackButton = styled.button `
  ${ButtonReset};
  ${fonts.apercu.light}

  color: ${brand.white};
  font-size: 15px;
  line-height: 32px;
  margin-bottom: 12px;
`;
const SubHeader = styled.div `
  ${fonts.altGothicNo2.regular};

  font-size: 20px;
  color: ${brand.white};
  text-transform: uppercase;
  line-height: 1.5;
  border-bottom: 1px solid ${brand.greyMid};
  padding-left: 14px;
  margin-bottom: 20px;
`;
const GeneralLink = styled.a `
  ${paragraphLarge};

  color: ${brand.white};
  text-decoration: none;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  padding-left: 14px;

  svg {
    color: ${brand.yellow};
    height: 14px;
    width: 14px;
  }

  &[data-view-all='true'] {
    margin-bottom: 27px;
  }
`;
const LinkList = styled.ul `
  padding-left: 14px;
`;
const EnquiriesButton = styled(LinkButton) `
  width: 100%;
  height: 55px;
  margin-bottom: 15px;
  flex-shrink: 0;
  
  span {
    margin: auto;
  }

  &[data-active='true'] {
    display:none;
  }
`;
const FindApartmentCTA = styled(LinkButton) `
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
  flex-shrink: 0;

  &[data-active='true'] {
    display:none;
  }
`;
const NavigationMobileStyles = {
    Container,
    QuickLinks,
    QuickLink,
    ItemContainer,
    TopLinks,
    TopLink,
    PreText,
    BackButton,
    SubHeader,
    GeneralLink,
    LinkList,
    EnquiriesButton,
    FindApartmentCTA,
};
export default NavigationMobileStyles;
